export const theme = {
  colors: {
    primary: "#047857",
    primaryDark: "#065f46",
    secondary: "#2563eb",
    danger: "#dc2626",
    warning: "#f59e0b",
    success: "#16a34a",
    bg: "#f8fafc",
    card: "#ffffff",
    text: "#111827",
    muted: "#6b7280",
    border: "#e5e7eb"
  },
  radius: {
    sm: "8px",
    md: "12px",
    lg: "18px",
    pill: "999px"
  },
  shadow: {
    card: "0 8px 24px rgba(15,23,42,0.08)",
    soft: "0 2px 10px rgba(0,0,0,0.06)"
  }
};